var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrease({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.868317L16.29 3.4627L11.41 8.99135L7.41 4.45967L0 12.8659L1.41 14.4633L7.41 7.66583L11.41 12.1975L17.71 5.07145L20 7.66583V0.868317H14Z",
    fill: "#00B69B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.868317L16.29 3.4627L11.41 8.99135L7.41 4.45967L0 12.8659L1.41 14.4633L7.41 7.66583L11.41 12.1975L17.71 5.07145L20 7.66583V0.868317H14Z",
    stroke: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.0f9925a1ce850803c19e5016dc306082.svg";
export { ForwardRef as ReactComponent };